import EventFiltersDialog from './EventFiltersDialog';

export default EventFiltersDialog;
export type {
  EventFiltersDialogProps,
  FiltersContentProps
} from './EventFiltersDialog';
